// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipContainer_tooltip__6xRwv","button":"TooltipContainer_button__li1gT","flex":"TooltipContainer_flex__PruiV"};